var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dropdown",
    _vm._b(
      {
        ref: "dropdownRef",
        staticClass: "c-template_dropdown",
        attrs: { trigger: _vm.trigger, placement: _vm.placement },
        scopedSlots: _vm._u([
          {
            key: "dropdown",
            fn: function () {
              return [
                _c(
                  "DropdownMenu",
                  _vm._g(
                    _vm._b(
                      {
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "custom",
                              fn: function ({ data }) {
                                return _c(
                                  "div",
                                  {},
                                  [
                                    _vm._t("customItem", null, {
                                      data: data,
                                      aliasData: data,
                                      dropdownCustomItem: data,
                                    }),
                                  ],
                                  2
                                )
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      },
                      "DropdownMenu",
                      _vm.$attrs,
                      false
                    ),
                    _vm.$listeners
                  )
                ),
              ]
            },
            proxy: true,
          },
        ]),
      },
      "el-dropdown",
      _vm.$attrs,
      false
    ),
    [[_vm._t("default")]],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }